<template>
    <b-card>
        <h1>Packning</h1><b-button variant="primary" @click="reload()">Starta om</b-button>
        <b-row>
            <b-col cols="4">
                <b-card>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <b>Datum:</b><br>
                                <datepicker v-model="currDate" :stepper="true">
                                </datepicker>
                            </b-col>
                            <b-col>
                                <b>Tur:</b> ({{ tourNameList.length }}st) <br />
                                <!-- {{ tourNameList }} -->
                                <b-select v-model="currTourNames" multiple :options="getTourNamesForCombo()"
                                    @change=""></b-select>
                            </b-col>
                        </b-row>
                        <b-row v-if="bookings">
                            <b-col>
                                <b-card>
                                    <b-card-header>Skanna</b-card-header>
                                    <b-card-body>
                                        <b-input ref="barcode" style="font-size:xx-large" v-model="barcode"
                                            autofocus></b-input>
                                        <div class="row">
                                            <div class="col">
                                                <b-button @click="barcode = null">Töm</b-button>
                                            </div>
                                            <div class="col">
                                                <b-button @click="selectLoadCarrier()"
                                                    :variant="getCurrentLoadCarrierTitle() == '(Ingen)' ? 'secondary' : 'success'">
                                                    <i class="fa-solid fa-basket-shopping"></i>&nbsp;
                                                    {{ getCurrentLoadCarrierTitle() == '(Ingen)' ? 'Välj lastbärare' :
                                                        getCurrentLoadCarrierTitle() }}
                                                </b-button>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row v-if="errTexts && errTexts.length > 0">
                            <b-col>
                                <b-alert show v-for="(e, i) in errTexts" :key="i">{{ e }}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-if="bookings && barcode">
                            <b-col>
                                <p>Registrera:</p>
                                <b-row v-for="(b, i) in userslist" :key="i">
                                    <b-col>
                                        <p><b-button variant="primary" pill block @click="register(b)">{{ b
                                        }}</b-button>
                                        </p>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col>
                <b-card v-if="bookings">
                    <b-card-header>
                        Antal: {{ bookings ? bookings.length : '-' }} ({{ getPackedOrders().length }} skannade, {{
                            bookings.length - getPackedOrders().length }} kvar)
                    </b-card-header>
                    <b-card-body>
                        <b-table sticky-header="600px" :items="bookings" :fields="fields" small no-border-collapse
                            class="packingtable">
                            <template v-slot:head()="h">
                                <h3>{{ h.label }}</h3>
                            </template>
                            <template v-slot:cell(isPacked)="row">
                                <b-icon-check-circle-fill v-if="row.item.isPacked"
                                    variant="success"></b-icon-check-circle-fill>
                                {{ row.item.packText }}
                                {{ row.item.packTime }}
                            </template>
                        </b-table>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-modal id="loadCarrierModal" v-model="loadCarrierSelectorVisible" title="Välj lastbärare" ok-only>
            <b-card>
                <b-card-header>
                    Aktiv lastbärare: <h2>{{ getCurrentLoadCarrierTitle() }}</h2><br />
                    <b-button variant="primary" v-if="!currLoadCarrier" @click="createNewLoadCarrier()">Skapa ny
                        lastbärare</b-button>
                    <b-button variant="primary" v-if="currLoadCarrier" @click="closeLoadCarrier()">Stäng
                        lastbärare</b-button>
                </b-card-header>
                <b-card-body>
                    <b-list-group>
                        <b-list-group-item v-for="(lc, i) in loadCarrierList" :key="i" @click="currLoadCarrier = lc"
                            :class="{ 'list-group-item-success': currLoadCarrier && currLoadCarrier.LoadCarrierId == lc.LoadCarrierId }"
                            style="cursor: pointer;">
                            {{ lc.LoadCarrierId }} - {{ lc.Comment }}<br />
                        </b-list-group-item>
                    </b-list-group>
                </b-card-body>
            </b-card>
            <!-- <b-list-group>
                <b-list-group-item v-for="(lc, i) in bookings[0].loadCarriers" :key="i">
                    {{ lc }}
                </b-list-group-item>
            </b-list-group> -->
        </b-modal>
    </b-card>
</template>
<script>
import datepicker from '@/components/datepicker.vue';
import moment from "moment";
import { Api } from '@/lib/api'
const api = new Api();



export default {
    name: 'pack',
    components: {
        datepicker
    },
    data() {
        return {
            currDate: moment(new Date()).format("YYYY-MM-DD"),
            currTourNames: [],
            tourNameList: null,
            bookings: null,
            fields: [
                { key: 'deliveryPlaceName', label: 'Mottagare', sortable: true, thClass: 'big-header' },
                { key: 'tspDocNo', label: 'Ordernr', sortable: true },
                { key: 'loadCarrierSummary', label: 'Lastbärare', sortable: true },
                { key: 'isPacked', label: 'Packad', sortable: true },
            ],
            errTexts: [],
            barcode: null,
            userslist: [],
            currLoadCarrier: null,
            loadCarrierList: [],
            loadCarrierSelectorVisible: false,
        }
    },
    watch: {
        currDate: function () {
            this.getTourNames();
            this.getBookings();
        },
        currTourNames: function () {
            this.getBookings();
        },
        barcode: function () {
            this.validate();
        }
    },
    mounted() {
        this.getTourNames();
        this.setFocusOnBarcode();
        this.loadPackers();
        // setTimeout(() => {
        //     this.setFocusOnBarcode();
        // }, 500);


    },
    methods: {
        loadPackers() {
            api.get('/api/sodexo/GetPackers').then(res => {
                this.userslist = res.data;
            })
        },
        getPackedOrders() {
            if (this.bookings)
                return this.bookings.filter(x => x.isPacked);
            return [];
        },
        getTourNamesForCombo() {
            return this.tourNameList?.map(x => { return { value: x, text: x } })
        },
        getTourNames() {
            api.get(`/api/sodexo/getToursForDate?datetext=${this.currDate}`).then(res => {
                this.tourNameList = res.data;
            })
        },
        getBookings() {
            var p = api.params({ datetext: this.currDate, tournames: this.currTourNames });
            api.get(`/api/sodexo/GetBookingsForPacking?${p}`).then(res => {
                this.bookings = res.data;
                this.bookings.forEach(b => {
                    if (b.loadCarriers && b.loadCarriers.length > 0)
                        b.loadCarrierSummary = b.loadCarriers.join(', ');
                });
            })
        },
        validate() {
            this.errTexts = [];
            var bc = this.barcode;
            if (!bc)
                return;

            var b = this.bookings.find(x => x.tspDocNo == bc);
            if (!b)
                this.errTexts.push(`Order ${this.barcode} finns ej i valda datum/turer.`);
            if (b.isPacked)
                this.errTexts.push(`Denna order är redan skannad!`)
            return true;
        },
        isValid() {
            return this.barcode && !(this.errTexts && this.errTexts.length > 0);
        },
        register(alias) {
            var b;
            if (this.bookings)
                b = this.bookings.find(x => x.tspDocNo == this.barcode);
            if (!b) {
                api.get('/api/sodexo/getpackinfo?tspDocNo=' + this.barcode).then(res => {
                    if (res.data.changedContext) {
                        var newDate = res.data.datetext;
                        var newTour = res.data.tourname;
                        // var orderNo = b.tspDocNo;
                        if (confirm(`Ordern ${this.barcode} ligger på tur '${newTour}' ${newDate}.\nVill du lägga till en tur till?`)) {
                            this.currDate = newDate;
                            //this.currTourName = newTour;
                            if (!this.currTourNames.includes(newTour))
                                this.currTourNames.push(newTour);
                        }
                        alert('Vänligen skanna ordern igen.')
                        this.barcode = null;
                        return;
                    }
                })
                return;
            }

            var p = {
                id: b.id,
                tspDocNo: b.tspDocNo,
                alias: alias,
                datetext: this.currDate,
                tourname: this.currTourName,
                loadCarrierId: this.currLoadCarrier ? this.currLoadCarrier.LoadCarrierId : null,
            }
            api.post(`/api/sodexo/registerpacked`, p).then(res => {
                this.getBookings();
                this.barcode = null;
                this.errTexts = [];
                this.setFocusOnBarcode();
                //alert('OK');
                if (!res.data) {
                    alert('Ett fel uppstod. Försök igen.');
                    return;
                }
                if (res.data.changedContext) {
                    var newDate = res.data.datetext;
                    var newTour = res.data.tourname;
                    var orderNo = res.data.tspDocNo;
                    if (this.currLoadCarrier) {
                        if (confirm(`Ordern ${orderNo} ligger på tur '${newTour}' ${newDate}.\nVill du att lastbäraren ${this.getCurrentLoadCarrierTitle()} ska ha en till tur?`)) {
                            this.currDate = newDate;
                            //this.currTourName = newTour;
                            if (!this.currTourNames.includes(newTour))
                                this.currTourNames.push(newTour);
                            alert('Vänligen skanna ordern igen.')
                        }
                        else
                            return;
                    }
                    else {
                        if (confirm(`Ordern ${orderNo} ligger på tur '${newTour}' ${newDate}.\nVill du byta aktuellt datum/tur?`)) {
                            this.currDate = newDate;
                            this.currTourName = [newTour];
                        }
                        alert('Vänligen skanna ordern igen.')
                        return;
                    }
                }
                if (res.data.errText) {
                    alert(res.data.errText);
                    return;
                }
                //Refresh data

            });
        },
        setFocusOnBarcode() {
            console.log('setFocusOnBarcode');
            if (this.$refs.barcode && this.bookings)
                this.$refs.barcode.focus();
            setTimeout(this.setFocusOnBarcode, 5000);
        },
        reload() {
            top.location.reload();
        },
        selectLoadCarrier() {
            this.refreshLoadCarrierList();
            this.loadCarrierSelectorVisible = true;
        },
        createNewLoadCarrier() {
            var newLcId = prompt('Ange ID för ny lastbärare:');
            if (!newLcId) {
                return;
            }
            api.get('/api/sodexo/getLoadCarrier?carrierId=' + newLcId).then(res => {
                if (res.data && res.data.length > 0) {
                    //TODO: Öppna vald lastbärare?
                    if (confirm('En lastbärare med detta ID finns redan. Väljer du att öppna den?')) {
                        this.currLoadCarrier = res.data[0];
                    }
                    return;
                }
                //OK, moveon
                var comment = prompt('Ange ev. kommentar för lastbäraren:');
                var p = {
                    loadCarrierId: newLcId,
                    comment: comment ?? '',
                }
                api.post('/api/sodexo/createLoadCarrier', p).then(res => {
                    if (res.data) {
                        alert('Lastbärare skapad!');
                        this.currLoadCarrier = res.data;
                    } else {
                        alert('Ett fel uppstod vid skapandet av lastbäraren. Försök igen.');
                    }
                })
            });
        },
        closeLoadCarrier() {
            if (confirm('Stäng lastbärare?')) {
                this.currLoadCarrier = null;
            }
        },
        getCurrentLoadCarrierTitle() {
            return this.currLoadCarrier ? `${this.currLoadCarrier.LoadCarrierId} ${this.currLoadCarrier.Comment}` : '(Ingen)';
        },
        refreshLoadCarrierList() {
            var lst = [];
            this.bookings.map(b => {
                if (b.loadCarriers && b.loadCarriers.length > 0) {
                    b.loadCarriers.map(lc => {
                        if (!lst.includes(lc))
                            lst.push(lc);
                    });
                }
            });
            this.loadCarrierList = lst.map(x => ({ LoadCarrierId: x, Comment: '' }));
            //Get Comments
            this.loadCarrierList.map(x => {
                api.get('/api/sodexo/getLoadCarrier?carrierId=' + x.LoadCarrierId).then(res => {
                    if (res.data && res.data.length > 0) {
                        x.Comment = res.data[0].Comment;
                    }
                });
            });
        }

    }
}

</script>
